<template>
  <TileDataContent
    :fids="fids"
    :forecast-label="forecastLabel"
    :dataset="dataset"
    :data-by-id="dataById"
  >
    <template #content-header>
      <TileDataContentHeaderTwoColumn>
        <template #second-column>
          Laadpunten
        </template>
      </TileDataContentHeaderTwoColumn>
    </template>

    <template #content="{ showData }">
      <TileDataContentRowTwoColumn>
        <template #first-column>
          Aantal
        </template>
        <template #second-column>
          {{ showData({ field: `laadpunt_${year}` }) }}
        </template>
      </TileDataContentRowTwoColumn>
    </template>

    <template #footer>
      ID: {{ fids[0] }}
    </template>
  </TileDataContent>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TileDataContentRowTwoColumn from '@/components/map/tiles/TileDataContentRowTwoColumn'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeaderTwoColumn from '@/components/map/tiles/TileDataContentHeaderTwoColumn'

export default {
  name: 'TileDataElaadFastcharge',
  components: { TileDataContentHeaderTwoColumn, TileDataContentRowTwoColumn, TileDataContent },
  mixins: [TiledataMixin],

}
</script>
